import '../../../../javascripts/mobile_header';
import '../../../../javascripts/common/common_header_mega';
import { bindClickEvents as initToggleButtons } from '../../../../javascripts/activate_target_id';
import { initForCategoryLandingPage as initKaitoriForm } from '../../../../javascripts/uridoki_plus_kaitori_form';

// 開閉ボタン用のスクリプト
window.addEventListener('DOMContentLoaded', initToggleButtons);

// ウリドキプラスから移植したPIXフォーム
window.addEventListener('DOMContentLoaded', initKaitoriForm);

// 価格計算ツール
window.addEventListener('DOMContentLoaded', () => {
  const targetType = document.getElementById('js-categories-lp-price-tool-type');
  const targetWeight = document.getElementById('js-categories-lp-price-tool-weight'); 
  const targetPrice = document.getElementById('js-categories-lp-price-tool-price');
  if (!targetType || !targetWeight || !targetPrice) {
    return;
  }
  targetType.onchange = targetWeight.onchange = () => {
    const type = targetType.value;
    const weight = targetWeight.value;
    if (type === '' || weight === '') {
      targetPrice.textContent = '';
      return;
    }
    const price = type * weight;
    targetPrice.textContent = price;
  };
});
